import axios from "axios";
import { logout } from "../lib/auth";
import { accountTableColumn } from "../config/account";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// MGR商材権限一覧取得
// forEdit: true のときは自社のグループのみ返す（アカウント編集時のグループ選択用。協業パートナーのグループは選択不可）
export async function getAccountMgrGroups(id: string, options?: { forEdit?: boolean }) {
  try {
    const path = "accountMgrGroups";
    const params: { id: string; for_edit?: string } = { id };
    if (options?.forEdit) params.for_edit = "1";
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null" || response.data.fetch_data == null) {
      return {
        sudDatas: [],
        groupDatas: response.data.group_data ?? [],
      };
    }
    return {
      sudDatas: response.data.fetch_data,
      groupDatas: response.data.group_data ?? [],
    };
  } catch (error) {
    return { sudDatas: [], groupDatas: [] };
    // logout();
  }
}

// MGR商材権限登録
export async function postAccountMgrGroup(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "accountMgrGroup";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
